import { render, staticRenderFns } from "./add-edit-sub-region.vue?vue&type=template&id=519d9e38&"
import script from "./add-edit-sub-region.vue?vue&type=script&lang=js&"
export * from "./add-edit-sub-region.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports